export interface State {
  selectedClientId: string | null
  selectedYearId: string | null
  selectedProgramId: string | null
  selectedStructureId: string | null
  clientName: string | null
  yearLabel: string | null
  programName: string | null
  contextLoaded: boolean
}

export const initialState: State = {
  selectedClientId: null,
  selectedYearId: null,
  selectedProgramId: null,
  selectedStructureId: null,
  clientName: null,
  yearLabel: null,
  programName: null,
  contextLoaded: false,
}
